import { render } from "./intros-feedback-settings.vue?vue&type=template&id=27a5185e&lang=pug"
import script from "./intros-feedback-settings.vue?vue&type=script&setup=true&lang=js"
export * from "./intros-feedback-settings.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__